export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    const context = this

    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

// transforms date to DD/MM/YYY HH:MM:SS format
export function formatDate(dateStr: string, showTime: boolean = true) {
  if (!dateStr) {
    return ' - '
  }
  // Replace "UTC" with "Z" to make it an ISO 8601 string
  const isoString = dateStr.replace('UTC', 'Z')
  // Parse the ISO string to a Date object
  const date = new Date(isoString)

  // Extract date components
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are zero-based
  const year = date.getUTCFullYear()
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  const seconds = String(date.getUTCSeconds()).padStart(2, '0')

  // Format the date as dd/mm/yyyy hh:mm:ss
  if (showTime) {
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
  } else {
    return `${day}.${month}.${year}`
  }
}

export function formatPhoneNumber(number: string) {
  number = number.replace(/\s+/g, '')
  if (number.startsWith('+')) {
    return (
      number.slice(0, 4) +
      ' ' +
      number
        .slice(4)
        .replace(/.{1,3}/g, '$& ')
        .trim()
    )
  } else {
    return number.replace(/.{1,3}/g, '$& ').trim()
  }
}

export function getNestedField(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj)
}
